'use strict';

import { combineReducers } from 'redux';
import appReducer from '@/state/domains/app';
import usersReducer from '@/state/domains/users';
import userStatsReducer from '@/state/domains/userStats';
import ordersReducer from '@/state/domains/orders';
import locationsReducer from '@/state/domains/locations';
import locationListReducer from '@/state/domains/locationList';
import assignmentsReducer from '@/state/domains/assignments';
import attemptsReducer from '@/state/domains/attempts';
import errorsReducer from '@/state/domains/errors';
import jobsTableReducer from '@/state/domains/jobsTable';
import placesReducer from '@/state/domains/places';

const loadingReducer = (state = false, action) => {
	
	if (/(FETCH|POST)/.test(action.type)) {
		if (/(FAILED|COMPLETED)$/.test(action.type)) {
			return false;

		} else {
			return !action.meta.byPassLoading
		}
	} else if (/ADD_ERROR/.test(action.type)) {
		return false;
	}

	return state;
}

const jobImportReducer = (state = { errors: [], jobIds: [] }, action) => {
	switch(action.type) {
		case 'users/POST_IMPORT_JOBS_COMPLETED':
			const { errors, jobIds } = action.data;
			return { errors, jobIds };
		default:
			return state;
	}
};

/*const locationReducer = (state = {
	pathname: null,
	search: null,
	hash: null,
	state: null,
	action: null,
	key: null

}, action) => {

	if (action.type === 'UPDATE_LOCATION') {
		return Object.assign({}, state, action.payload)
	}
	return state;

}*/

const rootReducer = combineReducers({
	app: appReducer,
	users: usersReducer,
	//userStats: userStatsReducer,
	orders: ordersReducer,
	locations: locationsReducer,
	locationList: locationListReducer,
	assignments: assignmentsReducer,
	attempts: attemptsReducer,
	errors: errorsReducer,
	loading: loadingReducer,
	jobImport: jobImportReducer,
	jobsTable: jobsTableReducer,
	places: placesReducer,
});

export default rootReducer;
